import FouSelect from 'components/form/fou-select'
import FouContainer from 'components/tools/fou-container/'
import FouModal from 'components/overlay/fou-modal/'
import FouGrid from 'components/layout/fou-grid/'
import FouGroup from 'components/layout/fou-group/'
import MyfontsShortCircleIcon from 'components/icons/myfonts-short-circle/'
import FouPicture from 'components/tools/fou-picture/'
import { FouSelectObject } from 'src/utils/objects/fou-select'
import Methods from './defaultStyle.methods'
import SubmissionComputed from 'src/pages/submissions/script/common.computed'
import SubmissionMethods from 'src/pages/submissions/script/common.methods'
import VSelect from 'src/components/form/v-select/index.vue'
import { useForm } from 'vee-validate'
import { mapGetters } from 'vuex'

export default {
  name: 'defaultStyle',

  data() {
    return {
      displaystyle: FouSelectObject()
    }
  },

  setup() {
    const { errors, validate } = useForm()
    return {
      errors,
      validate
    }
  },

  components: {
    FouSelect,
    FouContainer,
    FouModal,
    MyfontsShortCircleIcon,
    FouPicture,
    ...FouGrid,
    FouGroup,
    VSelect
  },

  computed: {
    ...SubmissionComputed,
    ...mapGetters('binaries', {
      binariesList: ['list']
    })
  },

  methods: {
    ...SubmissionMethods,
    ...Methods,
    optionDeselected() {
      this.displaystyle.values = this.displaystyle.options.find(
        option => option.label === this.binariesList[0].styleName
      )

      this.updateDisplayStyleValues(this.displaystyle.values)
    },
  },

  watch: {
    errors: {
      handler(newVal) {
        this.updateSubmissionErrors(newVal, 'display style upload')
      },
      immediate: true
    }
  },

  created() {
    this.setSubmissionBuild({
      before: this.buildSubmission,
      after: this.refresh
    })
    this.setDisplayStyle()
    this.$events?.$on('submission:results:update', this.refresh)
    this.$events?.$on('trigger:validate', () => {
      this.validate()
    })
  },

  beforeUnmount() {
    this.$events.$off('submission:results:update', this.refresh)
    this.$events?.$off('trigger:validate')
  }
}
